import PaginatedResponse from '../../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { MessagePostDto } from './model.dto'

@ObjectType()
export class MessagePostPagedResultDto extends PaginatedResponse(MessagePostDto) {
}
